// extracted by mini-css-extract-plugin
export default {"bookNowBtn":"BookNowBtn_bookNowBtn__aKR-6","change-color-on-hover":"BookNowBtn_change-color-on-hover__LQLLJ","button":"BookNowBtn_button__4LME-"};